// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tui-grid-btn-sorting{\n  float:right;\n  margin-top:3px;\n  color: gray;\n}\n", "",{"version":3,"sources":["webpack://./themes/etcrm2/frontend/src/components/widgets/module/tuigrid.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb","sourcesContent":[".tui-grid-btn-sorting{\n  float:right;\n  margin-top:3px;\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
